import request from '../../shared/request'

export function getCompaniesList() {
  return request('/company')
}

export function getAllCompaniesVendorClient() {
  return request('/company/all')
}

export function createNewCompany(payload) {
  return request(`/company/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateSavedCompany(payload) {
  return request(`/company/${payload.company_id}`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteCompany(payload) {
  return request(`/company/${payload.companyId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getCompanyLeads(payload) {
  return request(`/company/${payload.companyId}/leads`)
}

export function getCompanyJobs(payload) {
  return request(`/company/${payload.companyId}/jobs`)
}

// attachments
export function uploadAttachments(payload) {
  return request(`/company/${payload.companyId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(companyId) {
  return request(`/company/${companyId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/company/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/company/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// notes
export function fetchCompanyNote(payload) {
  return request(`/company/${payload.companyId}/notes`)
}

export function createCompanyNote(payload) {
  return request(`/company/${payload.companyId}/notes`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editCompanyNote(payload) {
  return request(`/company/${payload.noteId}/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteCompanyNote(payload) {
  return request(`/company/${payload.noteId}/notes`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/company.js